import React from 'react';
import { fetchPostQuery, useQuery } from '/src/api';
import graphQLQueries from './graph-ql-queries';

const useCustomerAddresses = () => {
    const { data: addresses, isLoading, runQuery, setValues } = useQuery({
        data: [],
        query: graphQLQueries.addresses,
        queryKey: ['customer', 'addresses'],
    });

    const createCustomerAddress = variables => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.createCustomerAddress,
            variables,
        }).then(response => {
            const data = [ ...addresses ];
            const { createCustomerAddress } = response;
            data.push(createCustomerAddress);

            setValues({ data, isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        })
    };

    const updateCustomerAddress = variables => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.updateCustomerAddress,
            variables,
        }).then(response => {
            const data = [ ...addresses ];
            const { updateCustomerAddress } = response;
            const index = data.findIndex(({ id }) => id === updateCustomerAddress.id);
            data[index] = updateCustomerAddress;

            setValues({ data, isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        })
    };

    const deleteCustomerAddress = id => {
        setValues({ isLoading: true });

        return fetchPostQuery({
            query: graphQLQueries.deleteCustomerAddress,
            variables: { id },
        }).then(response => {
            const data = [ ...addresses ];
            const { deleteCustomerAddress } = response;

            if (!deleteCustomerAddress) {
                throw [{ message: 'Something went wrong' }]
            }

            setValues({ data: data.filter(({ id: addressId }) => addressId !== id), isLoading: false });

            return response;
        }).catch(errors => {
            setValues({ isLoading: false });

            throw errors;
        })
    };

    return ({
        customerAddresses: addresses,
        isLoadingCustomerAddresses: isLoading,
        getCustomerAddresses: runQuery,
        createCustomerAddress,
        updateCustomerAddress,
        deleteCustomerAddress,
    })
};

export default useCustomerAddresses;
